import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

export type DropdownEntry = { value: string; label: string };

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    standalone: false,
})
export class DropdownComponent {
    @Input() inputLabel: string = '';
    @Input() control: FormControl<string>;
    @Input() options: DropdownEntry[] = [];

    @Output() valueChange: EventEmitter<string> = new EventEmitter();

    onValueChange(): void {
        if (this.control.enabled && this.control.valid) {
            this.valueChange.emit(this.control.value);
        }
    }
}
